<template>
    <span>
        <AdminDashboard v-if="user.role === 'admin'"/>
        <BuilderDashboard v-else-if="user.role === 'builder'"/>
        <SupportDashboard v-else-if="user.role === 'support'"/>
        <PlatformDashboard v-else-if="user.role !== 'support'"/>
    </span>
</template>

<script>
import { mapState } from 'vuex';
import PlatformDashboard from '@/views/PlatformDashboard';
import AdminDashboard from '@/views/AdminDashboard';
import BuilderDashboard from '@/views/BuilderDashboard';
import SupportDashboard from '@/views/SupportDashboard';

export default {
    components: { SupportDashboard, BuilderDashboard, AdminDashboard, PlatformDashboard },
    computed: {
        ...mapState('auth', ['user']),
    }
};
</script>
